import { Injectable } from "@angular/core";
import { HeatmapsRepoService } from "../../api/heatmaps-repo/heatmaps-repo.service";
import { DemoHasAccessService } from "../../../modules/demodata/services/demo-has-access.service";
import { DemoHeatmapsRepoService } from "../../../modules/demodata/endpoints/demo-heatmaps-repo/demo-heatmaps-repo.service";

@Injectable({
    providedIn: "root",
})
export class HeatmapApiService {
    constructor(
        private readonly heatmapsRepoService: HeatmapsRepoService,
        private readonly demoHasAccessService: DemoHasAccessService,
        private readonly demoHeatmapsRepoService: DemoHeatmapsRepoService
    ) {}

    create (domainId, params) {
        if (this.demoHasAccessService.isDemoHeatmaps()) {
            return this.demoHeatmapsRepoService.create(domainId, params);
        }

        return this.heatmapsRepoService.create(domainId, params);
    }

    destroy (domainId, ruleId) {
        if (this.demoHasAccessService.isDemoHeatmaps()) {
            return this.demoHeatmapsRepoService.destroy(domainId, ruleId);
        }

        return this.heatmapsRepoService.destroy(domainId, ruleId);
    }

    getAllFromCustomer (params) {
        if (this.demoHasAccessService.isDemoHeatmaps()) {
            return this.demoHeatmapsRepoService.getAllFromCustomer();
        }

        return this.heatmapsRepoService.getAllFromCustomer(params);
    }
}
